export const PLAN_PRICES = {
  USD: { free: 0, standard: 6.99, premium: 10.99 },
  INR: { free: 0, standard: 299, premium: 649 },
};

export const CURRENCY_SYMBOLS = {
  USD: '$',
  INR: '₹',
};

/* Billing terms. Longer terms are a straight multiple of the monthly rate —
   there is no term discount, so `months` is the only thing that varies.
   Keys match what the Razorpay billing API expects as `interval`. */
export const BILLING_INTERVALS = [
  { key: 'monthly', months: 1, label: 'Monthly', shortLabel: '/mo' },
  { key: 'quarterly', months: 3, label: '3 Months', shortLabel: '/3 mo' },
  { key: 'halfyearly', months: 6, label: '6 Months', shortLabel: '/6 mo' },
  { key: 'yearly', months: 12, label: '12 Months', shortLabel: '/yr' },
];

export function getIntervalMonths(interval) {
  return BILLING_INTERVALS.find((i) => i.key === interval)?.months || 1;
}

export function getIntervalLabel(interval) {
  return BILLING_INTERVALS.find((i) => i.key === interval)?.label || 'Monthly';
}

export function getIntervalShortLabel(interval) {
  return BILLING_INTERVALS.find((i) => i.key === interval)?.shortLabel || '/mo';
}

export function getCurrencySymbol(currency) {
  return CURRENCY_SYMBOLS[currency] || '$';
}

/* Per-seat price for one billing term. Defaults to monthly, so existing
   two-argument callers keep their current behaviour. */
export function getPlanPrice(plan, currency = 'USD', interval = 'monthly') {
  const normalized = (plan || 'free').toLowerCase();
  const mapping = { growth: 'standard', enterprise: 'premium' };
  const key = mapping[normalized] || normalized;
  const monthly = (PLAN_PRICES[currency] || PLAN_PRICES.USD)[key] ?? 0;
  const total = monthly * getIntervalMonths(interval);
  // Keep USD cents clean after multiplying (6.99 × 3 = 20.969999…).
  return Math.round(total * 100) / 100;
}

export function formatPlanPrice(plan, currency = 'USD', interval = 'monthly') {
  const symbol = getCurrencySymbol(currency);
  const price = getPlanPrice(plan, currency, interval);
  return `${symbol}${price}`;
}

export function formatAmount(amount, currency = 'USD') {
  const symbol = getCurrencySymbol(currency);
  if (Number.isInteger(amount)) return `${symbol}${amount}`;
  return `${symbol}${amount.toFixed(2)}`;
}
